export const CDN_ASSETS_URL = 'https://static-assets.vinted.com'
export const CDN_IMAGES_URL = `${CDN_ASSETS_URL}/images`
